// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/'
import routerConfig from './router/router'
import VueRouter from 'vue-router'
import common from "./common/common";
import api from './service/index'
import InfiniteScroll from 'element-ui/lib/infinite-scroll'
import Loading from 'element-ui/lib/loading'
import Select from 'element-ui/lib/select'
import Option from 'element-ui/lib/option'
import Carousel from 'element-ui/lib/carousel'
import CarouselItem from 'element-ui/lib/carousel-item'
import Timeline from 'element-ui/lib/timeline'
import TimelineItem from 'element-ui/lib/timeline-item'
import Tabs from 'element-ui/lib/tabs'
import TabPane from 'element-ui/lib/tab-pane'
import MessageBox from 'element-ui/lib/message-box'
import Upload from 'element-ui/lib/upload'
import Dialog from 'element-ui/lib/dialog'
import Buttons from 'element-ui/lib/button'
import Input from 'element-ui/lib/input'
import checkboxE from 'element-ui/lib/checkbox'
import Cascader from 'element-ui/lib/cascader'
import From from 'element-ui/lib/form'
import FromItem from 'element-ui/lib/form-item'
import Icon from 'element-ui/lib/icon'
import 'element-ui/lib/theme-chalk/index.css';
import VueAMap from 'vue-amap';

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    // 高德的key
    key: '7430de07aecd3bf54a4bd25df237de20',
    // 插件集合
    plugin: ['AMap.Geolocation'],
    // 高德 sdk 版本，默认为 1.4.4
    v: '1.4.4'
});

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.use(VueRouter)
Vue.use(InfiniteScroll)
Vue.use(Loading)
Vue.use(Select)
Vue.use(Option)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Buttons)
Vue.use(Input)
Vue.use(Cascader)
Vue.use(checkboxE)
Vue.use(From)
Vue.use(FromItem)
Vue.use(Icon)
Vue.prototype.$MessageBox = MessageBox;

import {DatetimePicker,Navbar,TabItem,TabContainer,TabContainerItem,Lazyload} from 'mint-ui';
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.use(Lazyload);
import 'mint-ui/lib/style.css'
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
const router = new VueRouter({
    routes:routerConfig
})

// import { Calendar,TreeSelect } from 'vant';
import 'vant/lib/index.css';

import { Area as area,Image as VanImage,TreeSelect,List,Calendar,Field,Button,Card,Tag,Cell,Tab as vanTab,
  CellGroup,Overlay,RadioGroup,Radio,Popup,Step, Steps,Dialog as VanDialog,CheckboxGroup,Checkbox,Loading as VanLoading,Tabs as vanTags,Icon as IconV} from 'vant';
import 'vant/lib/index.css';
Vue.use(VanImage);
Vue.use(VanLoading);
Vue.use(TreeSelect);
Vue.use(List);
Vue.use(Calendar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Card);
Vue.use(Tag);
Vue.use(vanTab);
Vue.use(vanTags);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Overlay);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Popup);
Vue.use(Step);
Vue.use(Steps);
Vue.use(TreeSelect);
Vue.use(Calendar);
Vue.use(VanDialog);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(IconV);
Vue.use(area);

Vue.directive('debounce', {
  inserted(el, binding, vnode) {
    let timer = {}
    el.addEventListener('click', () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        binding.value()
      }, 1000)
    })
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
     document.title = to.meta.title
  }
  next();
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js